import React, { createContext, useState, useContext, useCallback } from 'react';

const NotificationsContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotifications должен использоваться внутри NotificationsProvider');
  }
  return context;
};

export const NotificationsProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [userId, setUserId] = useState(null);

  const openNotifications = useCallback((userId) => {
    setUserId(userId);
    setIsOpen(true);
  }, []);

  const closeNotifications = useCallback(() => {
    setIsOpen(false);
    setUserId(null);
  }, []);

  return (
    <NotificationsContext.Provider value={{ 
      isOpen, 
      userId, 
      openNotifications, 
      closeNotifications 
    }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsContext;
